import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { isFetching } from 'utils/redux/fetching'
import { fetchCryptoCurrencies } from 'redux/actions/cryptoCurrencies'
import { fetchCryptoRates } from 'redux/actions/cryptoRates'
import Loader from 'components/Loader'
import CryptoCurrencyList from 'components/CryptoCurrencyList'
import MobileCurrencyListContainer from 'containers/MobileCurrencyListContainer'

class CryptoCurrencyListContainer extends Component {

	componentWillMount() {
		const { dispatch } = this.props
		dispatch(fetchCryptoCurrencies())
		dispatch(fetchCryptoRates())
	}
	render() {
		if (this.props.isFetching) return <Loader />
		const windowWidth = window.innerWidth
		const breakPoint = 980 
		
		return <div className='u-bg--white u-padding u-border-radius u-box-shadow'>
			{ (windowWidth < breakPoint) &&
				<MobileCurrencyListContainer {...this.props} />
			}
			{ (windowWidth >= breakPoint) &&
				<CryptoCurrencyList {...this.props}/>}
		</div>
	}
}

CryptoCurrencyListContainer.propTypes = {
	dispatch: PropTypes.func,
	isFetching: PropTypes.bool
}

const mapStateToProps = state => {

	const { cryptoRates, cryptoCurrencies } = state

	if (isFetching([cryptoRates, cryptoCurrencies])) return { isFetching: true }

	return {
		rates: cryptoRates.data
	}
}

export default connect(mapStateToProps)(CryptoCurrencyListContainer)
